<template>
  <div>
    <v-card>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title>
            <span class="text-h5"> Finalizar Pagamento </span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="3" sm="3" md="3">
                  <div class="campo-readonly">
                    <div class="campo-titulo">Total</div>
                    <div class="campo-valor">
                      {{ ObterValorFormatado(totais.total) }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="3" sm="3" md="3">
                  <div class="campo-readonly">
                    <div class="campo-titulo">Total de multa</div>
                    <div class="campo-valor">
                      {{ ObterValorFormatado(totais.multa) }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="3" sm="3" md="3">
                  <div class="campo-readonly">
                    <div class="campo-titulo">Total (IVA)</div>
                    <div class="campo-valor">
                      {{ ObterValorFormatado(totais.totalIva) }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="3" sm="3" md="3">
                  <div class="campo-readonly">
                    <div class="campo-titulo">Total de desconto (Linha)</div>
                    <div class="campo-valor">
                      {{ ObterValorFormatado(totais.desconto) }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="3" sm="3" md="3">
                  <div class="campo-readonly">
                    <div class="campo-titulo">Troco</div>
                    <div class="campo-valor">
                      {{ ObterValorFormatado(editedItemVenda.valorTroco) }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="3" sm="3" md="3">
                  <div class="campo-readonly">
                    <div class="campo-titulo">Saldo do estudante</div>
                    <div class="campo-valor">
                      {{ ObterValorFormatado(totais.saldo) }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="3" sm="3" md="3">
                  <div class="campo-readonly">
                    <div class="campo-titulo">Total (Geral)</div>
                    <div class="campo-valor">
                      {{ ObterValorFormatado(totais.totalGeral) }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="3" sm="3" md="3">
                  <div class="campo-readonly">
                    <div class="campo-titulo">valor pago</div>
                    <div class="campo-valor">
                      {{ editedItemVenda.valorPago }}
                    </div>
                  </div>
                </v-col>
              </v-row>

              <div class="valorEntregueContainer" v-if="!descontoSaldo">
                <div>
                  <v-text-field
                  v-if="!habilitar"
                    background-color="#ffff99"
                    :rules="ruleRequired"
                    @keyup="CalculaTroco()"
                    v-money="money"
                    v-model="pagamento1"
                  ></v-text-field>
                  <v-text-field
                  v-if="habilitar"
                    :disabled="true"
                    background-color="#ffff99"
                    :rules="ruleRequired"
                    v-model="pagamento1"
                  ></v-text-field>
                </div>
                <div>
                  <span>Valor Entregue ({{ forma1 }})</span>
                </div>
                <v-switch
                  v-if="!descontoSaldo"
                  @change="habilitar = !habilitar"
                  label="alterar valor entregue?"
                  color="primary"
                  value="primary"
                ></v-switch>
              </div>
              <div class="valorEntregueContainer" v-if="multiplasFormas && !descontoSaldo">
                <div>
                  <v-text-field
                    background-color="#ffff99"
                    @keyup="CalculaTroco()"
                    :rules="ruleRequired"
                    v-money="money"
                    v-model="pagamento2"
                  ></v-text-field>
                </div>
                <div>
                  <span>Valor Entregue ({{ forma2 }})</span>
                </div>
              </div>

              <v-row>
                <v-col cols="4" sm="4" md="4" v-if="descontoSaldo">
                  <v-chip style="margin-top: 14px"
                    >Valor a ser descontado do saldo.</v-chip
                  >
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <div style="display: flex; color: #fff">
                    <div class="form-check form-check-inline">
                      <input
                        v-model="opcaoSelected"
                        class="form-check-input"
                        type="radio"
                        name="inlineRadioOptions"
                        id="inlineRadio1"
                        value="1"
                      />
                      <label
                        class="form-check-label"
                        for="inlineRadio1"
                        style="margin-left: 4px; color: #000"
                        >Imagem do comprovativo</label
                      >
                    </div>

                    <div
                      class="form-check form-check-inline"
                      style="margin-left: 15px"
                    >
                      <input
                        v-model="opcaoSelected"
                        class="form-check-input"
                        type="radio"
                        name="inlineRadioOptions"
                        id="inlineRadio2"
                        value="2"
                      />
                      <label
                        class="form-check-label"
                        for="inlineRadio2"
                        style="margin-left: 4px; color: #000"
                        >Número do comprovativo</label
                      >
                    </div>
                  </div>

                  <v-card
                    v-if="opcaoSelected !== null && opcaoSelected === '1'"
                    style="margin-top: 10px"
                    tile
                  >
                    <a @click="$refs.file.click()"
                      ><i class="material-icons">attachment</i> Selecione o
                      ficheiro de FOTO</a
                    >
                    <v-list dense>
                      <v-subheader></v-subheader>
                      <v-list-item-group color="primary">
                        <v-list-item
                          v-for="(item, i) in arrayFicheiros"
                          :key="i"
                        >
                          <v-list-item-content>
                            <v-list-item-title
                              v-text="item.descricao"
                            ></v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-icon @click="removeFile(item)">
                            <v-icon style="color: red">delete</v-icon>
                          </v-list-item-icon>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-card>

                  <div v-if="opcaoSelected !== null && opcaoSelected === '2'">
                    <div class="valorEntregueContainer">
                      <div>
                        <v-text-field
                          background-color="#ffff99"
                          v-model="identificadorComprovativo"
                          label="Número de comprovativo"
                        ></v-text-field>
                      </div>
                      <div>
                        <span>{{ forma1 }}</span>
                      </div>
                    </div>
                    <div class="valorEntregueContainer" v-if="multiplasFormas">
                      <div>
                        <v-text-field
                          background-color="#ffff99"
                          v-model="identificadorComprovativo2"
                          label="Número de comprovativo"
                        ></v-text-field>
                      </div>
                      <div>
                        <span>{{ forma2 }}</span>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  style="color: white"
                  small
                  color="red darken-1"
                  @click="fecharCard()"
                  >Voltar</v-btn
                >
                <v-btn
                  style="color: white"
                  small
                  :disabled="!valid"
                  color="green darken-1"
                  @click="FinalizarCompra()"
                  >Continuar</v-btn
                >
              </v-card-actions>
            </v-container>
          </v-card-text>
        </v-card>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import utilitarios from "../../plugins/utilitarios";
const ls = require("local-storage");
const uuidv4 = require("uuid/v4");
import axios from "../../plugins/axios";
import Swal from "sweetalert2";
import { VMoney } from "v-money";
export default {
  directives: { money: VMoney },
  data() {
    return {
      utilitarios: utilitarios,
      habilitar: true,
      opcaoSelected: null,
      identificadorComprovativo: null,
      identificadorComprovativo2: null,
      arrayFicheiros: [],
      money: {
        decimal: ",",
        thousands: ".",
        suffix: " Kz",
        precision: 2,
        masked: false,
      },
      ruleRequired: [(value) => !!value || "campo obrigatorio"],
      dialogVenda: true,
      valid: true,
      habilitar: true,
      editedItemVenda: {
        precoTotal: 0,
        totalIva: 0,
        desconto: 0,
        valorApagar: 0,
        valorPago: 0,
        precoTotalNovo: 0,
        valorDesconto: 0,
        valorPagoDouble: 0,
        valorTroco: 0,
        descontoLinha: 0,
        totalMulta: 0,
      },

      editedItemVendaDefault: {
        precoTotal: 0,
        totalIva: 0,
        desconto: 0,
        valorApagar: 0,
        valorPago: 0,
        precoTotalNovo: 0,
        valorDesconto: 0,
        valorPagoDouble: 0,
        valorTroco: 0,
        totalMulta: 0,
      },
      forma1: "",
      forma2: "",
      pagamento1: undefined,
      pagamento2: undefined,
    };
  },

  props: {
    totais: Object,
    venda: Array,
    saldo: undefined,
    estudante: Array,
    tpa: Array,
    data: undefined,
    multiplasFormas: undefined,
    descontoSaldo: false
  },

  created() {
    this.editedItemVenda.valorPago = utilitarios.IntegerToMoneyValueFatura(
      this.saldo >= this.totais.totalGeral ? 0 : this.totais.totalGeral
    );

    this.editedItemVenda.iva = this.totais.totalIva

    if(this.saldo >= this.totais.totalGeral) {
      this.descontoSaldo = true;
    } 

    if (this.tpa.length == 2) {
      this.multiplasFormas = true;
      this.forma1 = this.tpa[0].descricao;
      this.forma2 = this.tpa[1].descricao;
    } else {
      this.multiplasFormas = false;
      this.forma1 = this.tpa[0].descricao;
      this.pagamento1 = utilitarios.IntegerToMoneyValueFatura(this.totais.totalGeral)
    }
  },

  methods: {
    ObterValorFormatado(valor) {
      let valorN =
        valor === null || valor === undefined || isNaN(valor) ? 0 : valor;
      let formated = new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "AOA",
      }).format(valorN);
      return formated.toString().replace("AOA", "") + "Akz";
    },

    fecharCard() {
      this.$emit("fecharCard", false);
    },

    CalculaTroco() {
      this.pagamento1 = this.pagamento1
        ? utilitarios.MoneyValueToInteger(this.pagamento1)
        : 0;
      this.pagamento2 = this.pagamento2
        ? utilitarios.MoneyValueToInteger(this.pagamento2)
        : 0;
      let somaPagamentos = this.pagamento1 + this.pagamento2;

      let troco =
        somaPagamentos -
        utilitarios.MoneyValueToInteger(this.totais.totalGeral);
      let calculoSaldo =
        somaPagamentos +
        this.saldo -
        utilitarios.MoneyValueToInteger(this.totais.totalGeral);

      if (troco > 0) {
        this.editedItemVenda.valorTroco = troco;
      } else {
        this.editedItemVenda.valorTroco = 0;
      }

      // if (troco < 0 && calculoSaldo < 0) {
      //   Swal.fire(
      //     "Informação",
      //     "O valor Entregue é insuficiênte ao total a pagar",
      //     "info"
      //   );
      //   this.valid = false;
      // } else {
      //   this.valid = true;
      // }
    },

    removeFile(item) {
      let index = this.arrayFicheiros.indexOf(item);
      this.arrayFicheiros.splice(index, 1);
    },

    previewImage: async function (event) {
      // Reference to the DOM input element
      var input = event.target;
      this.imageData = "";
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        let imagemJaExiste = this.arrayFicheiros.filter(
          (d) => d.descricao.toLowerCase() === input.files[0].name.toLowerCase()
        );
        if (imagemJaExiste.length <= 0) {
          // Entra, apenas se a imagem ainda não tenha sido adicionada na coleção
          let type = input.files[0].type;
          if (
            type === "image/png" ||
            type === "image/jpg" ||
            type === "image/jpeg"
          ) {
            const image = await this.process_image(input.files[0]);
            var reader = new FileReader();
            reader.readAsDataURL(input.files[0]);

            reader.onload = () => {
              // Read image as base64 and set to imageData
              this.imageData = image;
              this.arrayFicheiros.push({
                descricao: input.files[0].name,
                file: this.imageData,
              });
            };
          } else {
            Swal.fire(
              "Informação",
              "<p>Ficheiro inválido, selecione por favor uma imagem dos formatos ( PNG,JPG,JPEG ).</p>",
              "warning"
            );
          }
        }
      } else {
        this.imageData = "";
      }
    },

    FormatMoneyProperly(valor) {
      let v2 = valor.replace(".", "");
      let v3 = v2.replace(" Kz", "");
      let v4 = v3.replace(",", ".");
      return parseFloat(v4);
    },

    async FinalizarCompra() {
      this.pagamento1 = this.pagamento1
        ? utilitarios.MoneyValueToInteger(this.pagamento1)
        : 0;
      this.pagamento2 = this.pagamento2
        ? utilitarios.MoneyValueToInteger(this.pagamento2)
        : 0;
      let somaPagamentos = this.pagamento1 + this.pagamento2;
      let pagar = false
      let saldoPraDescontar = 0

      if (
        this.multiplasFormas &&
        (this.pagamento1 <= 0 || this.pagamento2 <= 0 && !this.descontoSaldo)
      ) {
        Swal.fire(
          "Informação",
          "Por favor, digite os valores entregues!",
          "info"
        );
      } else if (!this.multiplasFormas && this.pagamento1 <= 0 && !this.descontoSaldo) {
        Swal.fire("Informação", "Por favor, digite o valor entregue!", "info");
      } else if (
        this.multiplasFormas &&
        (!this.identificadorComprovativo || !this.identificadorComprovativo2 && !this.descontoSaldo)
      ) {
        Swal.fire(
          "Informação",
          "Por favor, digite ambos os números comprovativos!",
          "info"
        );
      } else if (!this.multiplasFormas && !this.identificadorComprovativo && !this.descontoSaldo) {
        Swal.fire(
          "Informação",
          "<p>Deve anexar o ficheiro ou informar o número do comprovativo de pagamento.</p>",
          "info"
        );
      } else {
        if (somaPagamentos < this.totais.totalGeral && !this.descontoSaldo) {
          if (somaPagamentos + this.saldo < this.totais.totalGeral) {
            pagar = false
            Swal.fire(
              "Informação",
              "O valor Pago inserido é insuficiênte",
              "info"
            );
          } else if(somaPagamentos + this.saldo >= this.totais.totalGeral) {
            saldoPraDescontar = this.totais.totalGeral - somaPagamentos
            pagar = true
          }
        } else {
          pagar = true
        }
        
        if(pagar) {
          
          let params = {
            documento: "",
            tipoDocumento: null,
            cliente: this.estudante,
            nif: "",
            formaPagamento: 6,
            venda: this.venda,
            valorIliquido: this.totais.total,
            valorApagar: this.totais.totalGeral,
            valorPago: this.descontoSaldo ? 0 : somaPagamentos,
            troco: this.editedItemVenda.valorTroco
              ? this.editedItemVenda.valorTroco
              : 0,
            totalMulta: this.totais.multa,
            iva: this.totais.totalIva,
            desconto: this.totais.desconto,
            pkCaixa: ls.get("pkCaixa"),
            fkEntidade: null,
            recibo: null,
            recibos: [],
            ContasBancariasPk: [],
            tpa: this.tpa[0].id,
            tpaRef: this.tpa[0].descricao,
            formaPagamentoDescricao: this.tpa[0].descricao,
            tpa2: this.multiplasFormas ? this.tpa[1].id : null,
            tpaRef2: this.multiplasFormas ? this.tpa[1].descricao : "",
            formaPagamentoDescricao2: this.multiplasFormas
              ? this.tpa[1].descricao
              : "",
              pagamento1: this.pagamento1,
              pagamento2: this.pagamento2,
            ficheiros: this.arrayFicheiros,
            guid: uuidv4(),
            autor: ls.get("nomeUsuario"),
            clienteDados: this.estudante,
            identificadorComprovativo: this.identificadorComprovativo,
            identificadorComprovativo2: this.identificadorComprovativo2,
            dataPagamentoSelected: this.data,
            dataPagamentoLinha: this.data,
          };

          let htmlContent = `
            <p style="text-align: center;"><strong style="color: red;">OBS:</strong> Confirme os dados antes de finalizar o pagamento.</p>
            <div style="width: 90%; margin: 10 auto;">
              <div style="display: grid; grid-template-columns: 150px auto;">
                <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Nome:</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.cliente[0].nome}</div>
                <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Forma de pagamento:</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.formaPagamentoDescricao}</div>`;

          if (this.multiplasFormas) {
            htmlContent += `
              <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Forma de pagamento (2):</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.formaPagamentoDescricao2}</div>
            `;
          }

          htmlContent += `
          <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Data:</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${
                  params.dataPagamentoSelected
                }</div>
                <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Valor pago:</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${this.utilitarios.IntegerToMoneyValue(
                  params.valorPago
                )}</div>
                <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Desconto:</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${
                  params.desconto
                    ? this.utilitarios.IntegerToMoneyValue(params.desconto)
                    : this.utilitarios.IntegerToMoneyValue(0)
                }</div>
                <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Troco:</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${this.utilitarios.IntegerToMoneyValue(
                  params.troco
                )}</div>
                <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Multa:</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${this.utilitarios.IntegerToMoneyValue(
                  params.totalMulta
                )}</div>
                <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Saldo a descontar:</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${this.utilitarios.IntegerToMoneyValue(
                 saldoPraDescontar
                )}</div>
              </div>
            </div>
          `;

          Swal.fire({
            title: "Finalizar Pagamento",
            html: htmlContent,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "green",
            cancelButtonColor: "#d33",
            cancelButtonText: "Cancelar",
            confirmButtonText: "Finalizar",
            reverseButtons: true,
          }).then(async (result) => {
            if (result.isConfirmed) {
              try {
                let result = await axios
                  .post("/EfectuarVenda-escola-New", params)
                  .then((res) => res.data);
                if (result.affectedRows >= 1) {
                  this.$emit("pagamentoSucesso", true);
                }
              } catch (error) {
                if (error.toString().includes("406")) {
                  Swal.fire(
                    "Informação",
                    "O mês ou intervalo de meses selecionado é inválido.",
                    "warning"
                  );
                } else {
                  Swal.fire(
                    "Informação",
                    "Erro ao efectuar a operação!",
                    "error"
                  );
                }
              }
            }
          });
        }
      }
    },
  },
};
</script>

<style scoped>
.valorEntregueContainer {
  display: grid;
  grid-template-columns: 30% 40% auto;
  column-gap: 10px;
  align-items: center;
}
.campo-readonly {
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 10px;
}

.campo-titulo {
  font-weight: bold;
}

.campo-valor {
  margin-top: 5px;
}
</style>
